module.exports = __webpack_public_path__ + "media/directory/likes_icon_hover-e02ce710.svg";